import { ActiveUserWithStatus } from 'src/redux/data/user/modules/types';

export type SubscriptionService = 'EMAIL' | 'SMS';

export const validateUsersByService = (service: SubscriptionService) =>
  service === 'EMAIL'
    ? (user: ActiveUserWithStatus) => !!user
    : (user: ActiveUserWithStatus) => !!user.phone;
